/**
 * @file The Branding service
 * @author Heino Lenting
 */
import { SettingsService } from '../settings.service';
/**
 * Class for the branding service
 */
var BrandingService = /** @class */ (function () {
    /**
     * Constructs a BrandingService
     * @param settingsService Service for the settings
     */
    function BrandingService(settingsService) {
        this.imageCollection = {};
        this.imageCollection['icon'] = require('../../branding/standaard-icon-90x60.png');
        this.imageCollection['logo'] = require('../../branding/standaard-logo-220x60.png');
        // This is a temporary solution. If in the future more custom-specific branding is needed
        // we need to rewrite the build process and copy, for given customer, the assets. Now all the
        // assets are shared between customers.
        this.imageCollection['workslip'] = (settingsService.settings['customer'] !== 'vanmeeuwen') ? require('../../branding/standaard-workslip-220x60.png') : require('../../branding/vanmeeuwen-workslip-220x60.png');
    }
    /**
     * Get the custom image for given customer
     * @parm type The type of the custom image
     * @returns The message of the branding
     */
    BrandingService.prototype.getImage = function (type) {
        return (this.imageCollection[type]) ? (this.imageCollection[type]) : '';
    };
    return BrandingService;
}());
export { BrandingService };
